import styled from 'styled-components'

export const RiskDiagramEditorDiv = styled.div`
    position: relative;
    width: 100%;
    height: calc(100% - 40px);
    overflow: hidden;
    display: flex;
    flex-direction: row;
    padding: 5px;
    background: var(--gray-300);

    .diagram-template {
        position: relative;
        flex-direction: column;
        width: calc(100% - 400px);
        flex-grow: 1;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        overflow: hidden;
        border-top: 2px solid var(--gray-500);
        border-left: 2px solid var(--gray-500);
        border-bottom: 2px solid var(--gray-500);

        svg#bowtie-svg {
            background: var(--gray-200);
            cursor: move;

            #bowtie-container {
                .hazardLine {
                    stroke: var(--yellow-500);
                    stroke-width: 2px;
                    stroke-dasharray: 5 5;
                    opacity: 0.5;
                }

                .hazardAuxLine {
                    stroke: var(--gray-400);
                    stroke-width: 2px;
                    stroke-dasharray: 5 5;
                    opacity: 0.5;
                }
            }
        }
    }

    .diagram-list {
        flex-direction: column;
        width: 400px;
        flex-grow: 1;
        z-index: 1;
        box-shadow: -2px 0px 8px rgba(0, 0, 0, 0.12);
        background: var(--gray-0);
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        overflow: hidden;
        border-top: 2px solid var(--gray-500);
        border-right: 2px solid var(--gray-500);
        border-bottom: 2px solid var(--gray-500);
    }
`
